"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_sound__active__dark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ecd77e23-b045-4fc3-8c2e-9f16d7161e0e",
    x1: 127.05,
    y1: 29.14,
    x2: 127.05,
    y2: 167.52,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bdbdbd"
  }))), /*#__PURE__*/React.createElement("title", null, "sound-active-hi-dark"), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "58fc9a2c-06a9-44a3-a967-164170358e1a",
    "data-name": "Apps_ic"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.13,125.63H28.54a12.52,12.52,0,0,1-12.49-12.55V79.92A12.51,12.51,0,0,1,28.54,67.38H78.19l49.67-46a2.49,2.49,0,0,1,4.19,1.83V169.84a2.49,2.49,0,0,1-4.19,1.83l-49.67-46Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.19,125.63H28.54a12.52,12.52,0,0,1-12.49-12.55V79.92A12.51,12.51,0,0,1,28.54,67.38H78.19Z",
    transform: "translate(0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M127.86,21.33l-5.81,5.39V166.28l5.81,5.39a2.49,2.49,0,0,0,4.19-1.83V23.16A2.49,2.49,0,0,0,127.86,21.33Z",
    transform: "translate(0)",
    fill: "url(#ecd77e23-b045-4fc3-8c2e-9f16d7161e0e)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "616446b1-087d-45ca-8571-ba1edb8b7d00",
    "data-name": "77f18b41-157a-40ca-ab4d-ba994b0e9cf0",
    d: "M160.8,64a45.3,45.3,0,0,1,0,64.06h0",
    transform: "translate(0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "a4eb66fa-dce6-4baa-a465-6cb583246cf1",
    "data-name": "cdbd5f61-fd0a-4e50-ba06-a76e9b6374d3",
    d: "M150.18,76.63a27.51,27.51,0,0,1,0,38.9h0",
    transform: "translate(0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4.05
  }))));
}

var _default = ic_sound__active__dark;
exports.default = _default;